import { projectTreeItemTypeOptions } from '../../../../../../../react-query/project/query/use-get-project-tree-query'
import { SpinnerGrey } from '../../../../../../../components/stories/atoms/icons/special'
import { iconSizeOptions } from '../../../../../../../components/stories/atoms/icons/icons-sizes'
import {
  BodyTd,
  BodyTr
} from '../../../../../../../components/stories/organisms/table/styled-components'
import { ProjectMenuTableStatusContent } from '../../../../../styled-component'

export const CompanyProjectsTableStatusRow = ({ children, colSpan }) => (
  <BodyTr>
    <BodyTd colSpan={colSpan}>
      <ProjectMenuTableStatusContent>{children}</ProjectMenuTableStatusContent>
    </BodyTd>
  </BodyTr>
)

export const CompanyProjectsFolderStatusRow = ({
  childrenByFolderId,
  colSpan,
  folderChildrenStateById,
  formatMessage,
  row
}) => {
  if (row.original.type !== projectTreeItemTypeOptions.FOLDER) return null
  if (!row.getIsExpanded()) return null

  const query = folderChildrenStateById.get(row.original.id)

  if (query?.isLoading || query?.isFetching) {
    return (
      <CompanyProjectsTableStatusRow colSpan={colSpan}>
        <SpinnerGrey size={iconSizeOptions['ICON-M']} />
      </CompanyProjectsTableStatusRow>
    )
  }

  if (query?.isError) {
    return (
      <CompanyProjectsTableStatusRow colSpan={colSpan}>
        {formatMessage({
          id: 'moveItems_move_error',
          defaultMessage: 'Unable to load this folder'
        })}
      </CompanyProjectsTableStatusRow>
    )
  }

  if (query?.isFetched && !childrenByFolderId.get(row.original.id)?.length) {
    return (
      <CompanyProjectsTableStatusRow colSpan={colSpan}>
        {formatMessage({
          id: 'projects_folderEmpty',
          defaultMessage: 'No projects here'
        })}
      </CompanyProjectsTableStatusRow>
    )
  }

  return null
}
